import background from './background.svg'
import backgroundMobile from './background-mobile.svg'

import { default as arrow, ReactComponent as Arrow } from './arrow.svg'
import { default as coins, ReactComponent as Coins } from './coins.svg'
import { default as coinsDrop, ReactComponent as CoinsDrop } from './coins-drop.svg'
import { default as rouletteBorder, ReactComponent as RouletteBorder } from './roulette-border.svg'
import { default as star, ReactComponent as Star } from './star.svg'
import { default as viacertaLogo, ReactComponent as ViacertaLogo } from './viacerta-logo.svg'

export const SVG = {
  Arrow,
  Coins,
  CoinsDrop,
  RouletteBorder,
  Star,
  ViacertaLogo,
}

export const svgPaths = {
  arrow,
  background,
  backgroundMobile,
  coins,
  coinsDrop,
  rouletteBorder,
  star,
  viacertaLogo,
}
